import { render, staticRenderFns } from "./ImportCategoryProduct.vue?vue&type=template&id=0d44ac1d&"
import script from "./ImportCategoryProduct.vue?vue&type=script&lang=js&"
export * from "./ImportCategoryProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports